import React from "react";
import Header from "./components/header/header.jsx";
import About from "./components/about.jsx";
import Resume from "./components/resume.jsx";
import Portfolio from "./components/portfolio.jsx";
import ContactUs from "./components/contactus.jsx";
import Footer from "./components/footer.jsx";
import CustomCursor from "./components/CustomCursor.jsx";
import { useSmoothScroll } from "./hooks/useSmoothScroll";
import { useScrollSpy } from "./hooks/useScrollSpy";

function App() {
  useSmoothScroll();
  const activeSection = useScrollSpy([
    "home",
    "about",
    "resume",
    "portfolio",
    "contact",
  ]);

  return (
    <>
      <CustomCursor />
      <Header activeSection={activeSection} />
      <About />
      <Resume />
      <Portfolio />
      <ContactUs />
      <Footer />
    </>
  );
}

export default App;
